import { render, staticRenderFns } from "./CommissionView.vue?vue&type=template&id=5d41885a&"
import script from "./CommissionView.vue?vue&type=script&lang=ts&"
export * from "./CommissionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports